import { render, staticRenderFns } from "./ShowImage.vue?vue&type=template&id=62b19da2&scoped=true&"
import script from "./ShowImage.vue?vue&type=script&lang=js&"
export * from "./ShowImage.vue?vue&type=script&lang=js&"
import style0 from "./ShowImage.vue?vue&type=style&index=0&id=62b19da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b19da2",
  null
  
)

export default component.exports